<template>
	<div class="page-container full-width">
		<router-view>
		</router-view>
	</div>
</template>

<script>
import foundation from '@/mixins/foundation.js'

export default {
	name: 'HomePage',
	mixins: [foundation]
}
</script>

<style lang="scss" scoped>
</style>
